import { ReactNode } from 'react'

import FormattedText from 'shared/ui/FormattedText'

import { SectionContainer, SectionContent } from '../landings/styles'

import { StyledCustomPortableText } from './styles'

import styles from './HowMakeOrderMainSection.module.scss'

interface HowMakeOrderMainSectionProps {
  header: string
  content: string | ReactNode
}
export default function HowMakeOrderMainSection({
  header,
  content
}: HowMakeOrderMainSectionProps) {
  return (
    <SectionContainer $condensed>
      <SectionContent $top={3} $topMobile={3} $bottom={10} $bottomMobile={8}>
        <h1 className={styles.pageHeader}>
          <FormattedText text={header} />
        </h1>
        <StyledCustomPortableText style={{ textAlign: 'center' }}>
          {content}
        </StyledCustomPortableText>
      </SectionContent>
    </SectionContainer>
  )
}
